import React , {Fragment, useContext }from 'react'
import AppData from '../common/AppData'
import '../style/StoreInput.scss'
import { LanguageContext } from '../context/LanguageContext'
import {useState} from 'react'
import network from '../common/network'
import { useSelector } from 'react-redux'
import Loader from './Loader'
function StoreInput () {
    const { strings } = useContext(LanguageContext)

    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(false)

    const storeIdInput = React.useRef()
    const { isLoading } = useSelector(state=>state.languageChange)

    const handleSubmit = () => {

        let storeId = storeIdInput.current.value

        if(!storeId || (storeId && storeId.length !== 5)){
            setErrorMessage(strings.storeIdErrorMessage)
            return
        }
        setErrorMessage('')

        setLoading(true)

        network.getStoreDetails(
            storeId,
            res=>{
                setLoading(false)
                AppData.storeId = storeId
                localStorage.setItem('storeId', storeId)
                window.location.reload()
            }, 
            error=>{
                setLoading(false)
                setErrorMessage(strings.storeIdErrorMessage)
                return
            }
        )
    }

    const renderStoreSetUp = () => {  
        return (
            <Fragment>    
                <div className="refresh">
                    <input type="text" ref={storeIdInput} maxLength="5" placeholder={strings.enterStoreIdText}/>
                    <div className = 'store-error-message'>{errorMessage}</div>
                    {loading ? <div className='loading-container'>{strings.loadingText}<div className="loader"></div></div>
                        :<button type="button" className="button-1" onClick={handleSubmit}>{strings.confirmIdText}</button>}
                </div>
            </Fragment>
        )
    }

    if(isLoading) return <Loader languageFetched={!isLoading} />

    return(
        <div className="store-container">
            <div className="store-content">
                <div className="store-content-top">
                    
                    <div className="store-title">{strings.provideStoreId}</div> 
                      
                    <div className="info-icon-wrapper">
                        <div className="info-icon"></div>
                    </div>
                </div>
                { renderStoreSetUp() }
            </div>
        </div>
    )
}

export default StoreInput
